import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Card, Button } from 'components';
import { AiFillCloseCircle } from 'react-icons/ai';
import JsonView from 'react-json-view';

const LogDataModal = ({ _this }) => {
  let [isJson, setIsJson] = useState(false);

  useEffect(() => {
    try {
      let jsonData = JSON.parse(_this?.logDataToShow?.error);
      setIsJson(true);
    } catch (error) {
      setIsJson(false);
    }
  }, [_this?.logDataToShow?.error]);

  const closeModal = () => {
    _this.setLogDataToShow(null);
    _this?.setSeeLogDataModalOpen(false);
    setIsJson(false);
  };

  return (
    <Modal
      style={{ zIndex: 9999 }}
      show={_this?.seeLogDataModalOpen}
      onHide={() => closeModal()}
      size="lg"
      fullscreen="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="mt-16 h-[90%]"
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          Log data for {_this?.logDataToShow?.action}
        </Modal.Title>
        <AiFillCloseCircle size={30} onClick={() => _this?.setSeeLogDataModalOpen(false)} />
      </Modal.Header>
      <Modal.Body className="px-3">
        <Card className="mb-3 flex flex-col gap-4 mr-2">
          {_this?.logDataToShow?.message ? (
            <h3 className="text-xl mb-3">
              <strong>Message :</strong> {_this?.logDataToShow?.message}.
            </h3>
          ) : null}
          {isJson ? (
            <JsonView src={JSON.parse(_this?.logDataToShow?.error)} />
          ) : (
            <h3 className="text-xl">{_this?.logDataToShow?.error}</h3>
          )}
        </Card>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={() => closeModal()}>Go Back</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LogDataModal;
